/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { Link } from '@fluentui/react/lib/Link';
import { Stack } from '@fluentui/react/lib/Stack';
import { Property } from 'csstype';
import React from 'react';
import { FilterItem } from 'src/clu/appShell/CLUTestModelsFiltersBlade';
import { getCheckedItemNames } from 'src/clu/appShell/cluTestSetDetailsTabUtils';
import { LuisText } from 'src/core/components/LuisText';
import { PillContainer } from 'src/core/components/PillContainer';
import { getScopedTheme } from 'src/core/themes/luisStylist';

type FilteredItemPillsProps = {
    onClearFilters: () => void;
    clearFilteredItemsText: string;
    filteredItemsToShow: FilterItem[];
    onRemoveFilter: (itemName: string) => void;
};

const filtersTheme = getScopedTheme('Filters');

export const FilteredItemPills = (props: FilteredItemPillsProps) => {
    const { filteredItemsToShow, onRemoveFilter, onClearFilters, clearFilteredItemsText } = props;

    return getCheckedItemNames(filteredItemsToShow).length ? (
        <Stack horizontal>
            <PillContainer
                allowAddPills={false}
                pills={filteredItemsToShow
                    .filter(item => item.isChecked)
                    .map((item, index) => ({
                        index,
                        name: item.itemName,
                        pillKey: `${item.itemName}-${index}`,
                        onRemovePill: () => onRemoveFilter(item.itemName),
                        onRenderPillContent: () => (
                            <LuisText title={item.itemName} fontWeight={filtersTheme.boldFontWeight as Property.FontWeight}>
                                {item.itemName}
                            </LuisText>
                        )
                    }))}
            />
            <Link as="button" onClick={() => onClearFilters()}>
                <span aria-label={clearFilteredItemsText}>{clearFilteredItemsText}</span>
            </Link>
        </Stack>
    ) : null;
};
